import styled from 'styled-components'
import Button from './Button'
import { ButtonProps } from './types'

const NetworkIconButton = styled(Button)<ButtonProps>`
  border-radius: 50%;
  color: '#44C4E2';
  margin: '0px';
  padding: '0px';
`

export default NetworkIconButton
